import { Link } from 'react-router-dom';

const packagingCards = [
  {
    title: '彩盒',
    desc: '具備極佳的品牌視覺吸睛度與大面積資訊展示空間，能為內部各式劑型如瓶裝、裝袋、裝片等提供外層防撞與便利陳列的保護',
    img: 'https://readdy.ai/api/search-image?query=health%20supplement%20product%20color%20box%20packaging%20elegant%20white%20box%20with%20green%20botanical%20accents%20design%20professional%20branding%2C%20clean%20bright%20studio%20lighting%20minimal%20composition%20health%20food%20supplement%20packaging&width=600&height=400&seq=pack-box-01&orientation=landscape',
  },
  {
    title: '瓶罐',
    desc: '具備優異的重複密封性與化學穩定性，是大容量膠囊、錠劑、粉劑、液體等長期包存與多次取用的首選',
    img: 'https://readdy.ai/api/search-image?query=amber%20glass%20bottles%20white%20plastic%20jars%20for%20vitamins%20supplements%20capsules%20displayed%20on%20clean%20white%20surface%2C%20health%20supplement%20container%20packaging%20professional%20studio%20photography%20bright%20clean&width=600&height=400&seq=pack-bottle-01&orientation=landscape',
  },
  {
    title: '鋁袋',
    desc: '擁有頂級的阻光與防潮高阻隔性，材質輕盈且便於攜帶，能完美密封單次分量的粉末、顆粒、液體等',
    img: 'https://readdy.ai/api/search-image?query=silver%20aluminum%20foil%20stand%20up%20pouches%20for%20health%20supplement%20powder%20packaging%20with%20ziplock%20closure%2C%20clean%20white%20background%20professional%20packaging%20design%20photography%20flat%20lay&width=600&height=400&seq=pack-pouch-01&orientation=landscape',
  },
  {
    title: 'PTP打片',
    desc: '提供單顆獨立的防潮衛生防護且便於精準控量，是最適合錠劑、膠囊的隨身攜帶型單元包裝',
    img: 'https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/77700c51e1de5ecc67e387a4c461ae4a.jpeg',
  },
];

export default function ServiceCompareSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
            包材設計
          </span>
          <h2 className="text-[#1a2e1a] font-bold mb-4">
            專業包材設計服務
          </h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
            完美適配各式劑型，整合彩盒、瓶罐、鋁袋與 PTP 打片，量身打造兼具防護與質感的完美外衣
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {packagingCards.map((card) => (
            <div
              key={card.title}
              className="bg-[#f7faf7] rounded-2xl overflow-hidden border border-gray-100 group hover:border-green-200 transition-all duration-300"
            >
              <div className="w-full h-64 sm:h-72 lg:h-80 overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-[#1a2e1a] font-bold text-[1.125rem] mb-3">{card.title}</h3>
                <p className="text-gray-600 text-[0.9375rem] leading-[1.75]">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] mb-6">
            如果您有其他問題歡迎查看更多常見問題，或是直接與我們聯繫
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/cooperation/faq"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[1rem] px-8 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              常見問題
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/contact/form"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 border border-[#4CAF50] text-[#4CAF50] hover:bg-[#4CAF50] hover:text-white font-semibold text-[1rem] px-8 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              聯絡我們
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}